<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <b-card class="bg-light shadow-sm border-0">
          <div class="row">
            <div
              class="col-12 col-xl-3"
            >
              <div class="row">
                <div
                  class="col-12 col-xl-2 d-flex align-items-center"
                >
                  <label class="mb-xl-0">Tenant</label>
                </div>
                <div
                  class="col-12 col-xl-10"
                >
                  <b-form-select
                    v-model="tenantSelection"
                    class="rounded-pill"
                  >
                    <option :value="null">
                      All Tenants
                    </option>
                    <option
                      v-for="tenant in tenants"
                      v-bind="$attrs"
                      :key="tenant.id"
                      :value="{ id: tenant.id }"
                      @option="$emit('option', $event.target.value)"
                    >
                      {{ tenant.name }}
                    </option>
                  </b-form-select>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-xl-7 mt-4 mt-xl-0"
            >
              <div class="row">
                <div
                  class="col-12 col-xl-2 text-right d-flex align-items-center"
                >
                  <label class="mb-xl-0">Time Period</label>
                </div>
                <div
                  class="col-12 col-xl-5"
                >
                  <b-form-input
                    id="dateFrom"
                    v-model="dateFrom"
                    type="date"
                    class="date-picker rounded-pill"
                    name="dateFrom"
                    placeholder="YYYY-MM-DD"
                  />
                </div>
                <div
                  class="col-12 col-xl-5 mt-2 mt-xl-0"
                >
                  <b-form-input
                    id="dateTo"
                    v-model="dateTo"
                    type="date"
                    class="date-picker rounded-pill"
                    name="dateTo"
                    placeholder="YYYY-MM-DD"
                  />
                </div>
              </div>
            </div>
            <div
              class="col-12 col-xl-2 mt-4 mt-xl-0"
            >
              <button
                type="submit"
                class="btn btn-primary px-4 pull-right"
                :disabled="applyBtnDisabled"
                @click.prevent="applyButtonClicked"
              >
                <span class="px-4">Apply</span>
              </button>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-12 col-lg-6 col-xl-3 d-flex align-items-stretch">
          <div class="card flex-grow-1">
            <div class="card-body align-items-center">
              <div class="row">
                <div class="col-8">
                  <div class="mb-3 ">
                    Total Delivered Devices
                  </div>
                  <div class="font-xl font-weight-bold">
                    <span v-if="!isLoadingOrdersAndRegistrationsList">
                      {{ ordersAndRegistrationsList[0]? ordersAndRegistrationsList[0].total_delivered : 0 }}
                    </span>
                    <span v-else>
                      <i class="fa fa-spinner fa-spin" />
                    </span>
                  </div>
                </div>
                <div class="col-4 text-right">
                  <div class="icon-background">
                    <img
                      src="static/img/delivered_devices.svg"
                      alt="Total Delivered Devices"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-3 d-flex align-items-stretch">
          <div class="card flex-grow-1">
            <div class="card-body align-items-center">
              <div class="row">
                <div class="col-8">
                  <div class="mb-3">
                    Total Registered Devices
                  </div>
                  <div class="font-xl font-weight-bold">
                    <span v-if="!isLoadingOrdersAndRegistrationsList">
                      {{ ordersAndRegistrationsList[0]? ordersAndRegistrationsList[0].total_registered : 0 }}
                    </span>
                    <span v-else>
                      <i class="fa fa-spinner fa-spin" />
                    </span>
                  </div>
                </div>
                <div class="col-4 text-right">
                  <div class="icon-background">
                    <img
                      src="static/img/registered_devices.svg"
                      alt="Total Registered Devices"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-3 d-flex align-items-stretch">
          <div class="card flex-grow-1">
            <div class="card-body align-items-center">
              <div class="row no-gutters align-items-center">
                <div class="col-8">
                  <div class="mb-3">
                    Post Repair NPS
                  </div>
                  <div class="row position-relative">
                    <div class="col-6">
                      <div class="font-xl font-weight-bold">
                        <span v-if="isLoadingMarketingMetricsList">
                          <i class="fa fa-spinner fa-spin" />
                        </span>
                        <span v-else>
                          {{ marketingMetricsList[0] ? (marketingMetricsList[0].nps_count?
                            marketingMetricsList[0].nps_count : 'N/A') : 'N/A' }}
                        </span>
                      </div>
                      <div class="font-xs">
                        <small>Total respondents</small>
                      </div>
                    </div>
                    <div class="separator" />
                    <div class="col-6">
                      <div class="font-xl font-weight-bold">
                        <span v-if="isLoadingMarketingMetricsList">
                          <i class="fa fa-spinner fa-spin" />
                        </span>
                        <span v-else>
                          {{ marketingMetricsList[0] ? (marketingMetricsList[0].nps?
                            marketingMetricsList[0].nps : 'N/A') : 'N/A' }}
                        </span>
                      </div>
                      <div class="font-xs">
                        <small>Actual score</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <DoughnutChart
                      :chart-data="npsChartData"
                      :options="{
                        displayEndCap: true,
                        maxHeight: '90px'
                      }"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-3 d-flex align-items-stretch">
          <div class="card flex-grow-1">
            <div class="card-body align-items-center">
              <div class="row no-gutters align-items-center">
                <div class="col-8">
                  <div class="mb-3">
                    Post Repair CSAT
                  </div>
                  <div class="row position-relative">
                    <div class="col-6">
                      <div class="font-xl font-weight-bold">
                        <span v-if="isLoadingMarketingMetricsList">
                          <i class="fa fa-spinner fa-spin" />
                        </span>
                        <span v-else>
                          {{ marketingMetricsList[0] ? (marketingMetricsList[0].csat_count ? marketingMetricsList[0].csat_count : 'N/A') : 'N/A' }}
                        </span>
                      </div>
                      <div class="font-xs">
                        <small>Total respondents</small>
                      </div>
                    </div>
                    <div class="separator" />
                    <div class="col-6">
                      <div class="font-xl font-weight-bold">
                        <span v-if="isLoadingMarketingMetricsList">
                          <i class="fa fa-spinner fa-spin" />
                        </span>
                        <span v-else>
                          {{ marketingMetricsList[0] ? (marketingMetricsList[0].satisfied_csat_percentage ? parseFloat(marketingMetricsList[0].satisfied_csat_percentage).toFixed(1) : 'N/A') : 'N/A' }}%
                        </span>
                      </div>
                      <div class="font-xs">
                        <small>
                          <span>% satisfied</span>
                          <i 
                            v-b-tooltip.hover.bottom 
                            class="fa fa-info-circle ml-1" 
                            :title="'% of customers satisfied\n(rated 4 or 5)'"
                          />
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <DoughnutChart
                    :chart-data="csatChartData"
                    :options="{
                      displayEndCap: true,
                      maxHeight: '90px'
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          class="col-12 col-xl-8"
        >
          <div class="card">
            <div class="card-body align-items-center">
              <div
                v-if="isLoadingMonthlyRegistrationsList"
                class="text-center"
              >
                <i class="fa fa-spinner fa-spin" />
              </div>
              <template v-else>
                <BarComboChart
                  title="Registered Devices"
                  :chart-data="{
                    labels: registeredDeviceCategories || [],
                    datasets: [
                      {
                        label: 'New Registered',
                        type: 'bar',
                        data: totalRegisteredDevices || [],
                        backgroundColor: '#0F2C29',
                        borderColor: '#0F2C29',
                        borderWidth: 1,
                        borderRadius: 4,
                        barPercentage: 0.1,
                        categoryPercentage: 1,
                        yAxisID: 'y-axis-1'
                      },
                      {
                        label: 'Cumulative Registered',
                        type: 'line',
                        data: cumulativeRegisteredDevices || [],
                        borderColor: '#22D3C5',
                        backgroundColor: 'transparent',
                        borderWidth: 4,
                        fill: true,
                        tension: 0,
                        pointBackgroundColor: '#22D3C5',
                        pointBorderColor: '#22D3C5',
                        pointRadius: 0,
                        pointHoverRadius: 0,
                        yAxisID: 'y-axis-2'
                      }
                    ]
                  }"
                />
              </template>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-4 d-flex">
          <div class="card card-body border-brand bg-brand-fill">
            <h4 class="font-weight-bold mb-1">
              ROI Dashboard
            </h4>
            <p
              v-if="lastUpdatedDate"
              class="mb-3"
              style="color: #22D3C5; font-size: 0.8rem;"
            >
              Last updated: {{ lastUpdatedDate }}
            </p>
            <div
              v-else
              class="mb-3"
            />
            <div class="d-flex justify-content-between">
              <div>
                Average Cost To Claim
              </div>
              <div class="text-right text-brand font-weight-bold font-lg">
                <span v-if="!isLoadingDamageCausingRepairs && !isLoadingWorkOrderClaimSavings">
                  {{ averageCostToClaim() | currency(currencyCode) }}
                </span>
                <i
                  v-else
                  class="fa fa-spinner fa-spin"
                />
              </div>
            </div>
            <hr>
            <div class="d-flex justify-content-between">
              <div>
                Claims Saved
              </div>
              <div class="text-right text-brand font-weight-bold font-lg">
                <span v-if="!isLoadingDamageCausingRepairs">
                  {{ damageCausingRepairsFixed }}
                </span>
                <i
                  v-else
                  class="fa fa-spinner fa-spin"
                />
              </div>
            </div>
            <hr>
            <div class="d-flex justify-content-between">
              <div>
                Estimated Claims Savings
              </div>
              <div class="text-right text-brand font-weight-bold font-lg">
                <span v-if="!isLoadingWorkOrderClaimSavings">
                  {{ estimatedClaimsSavings() | currency(currencyCode) }}
                </span>
                <i
                  v-else
                  class="fa fa-spinner fa-spin"
                />
              </div>
            </div>
            <hr>
            <div class="d-flex justify-content-between">
              <div>
                Cost of Program
              </div>
              <div class="text-right text-brand font-weight-bold font-lg">
                <span v-if="!isLoadingCostOfProgramme">
                  {{ programme() | currency(currencyCode) }}
                </span>
                <i
                  v-else
                  class="fa fa-spinner fa-spin"
                />
              </div>
            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center">
              <div>
                Return On Investment
              </div>
              <div class="text-right text-brand-secondary font-weight-bold font-xl">
                <span v-if="!isLoadingCostOfProgramme && !isLoadingWorkOrderClaimSavings">
                  {{ roi() }}
                </span>
                <i
                  v-else
                  class="fa fa-spinner fa-spin"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-4">
          <div class="row">
            <div class="col-12 col-xl-6">
              <div class="card flex-grow-1">
                <div class="card-body align-items-center">
                  <div class="mb-3">
                    Leak Alerts
                  </div>
                  <div class="font-xl font-weight-bold">
                    <span v-if="!isLoadingLowLeakAlerts">
                      {{ lowLeakAlerts.total_lowleak_alerts }}
                    </span>
                    <span v-else>
                      <i class="fa fa-spinner fa-spin" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-xl-6">
              <div class="card flex-grow-1">
                <div class="card-body align-items-center">
                  <div class="mb-3">
                    Repair Visits
                  </div>
                  <div class="font-xl font-weight-bold">
                    <span v-if="!isLoadingRepairs">
                      {{ repairs.total_repairs }}
                    </span>
                    <span v-else>
                      <i class="fa fa-spinner fa-spin" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card flex-grow-1">
                <div class="card-body align-items-center">
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        Claims Saved
                      </div>
                      <div class="font-xl font-weight-bold">
                        <span v-if="!isLoadingDamageCausingRepairs">
                          {{ damageCausingRepairs }}
                        </span>
                        <span v-else>
                          <i class="fa fa-spinner fa-spin" />
                        </span>
                      </div>
                    </div>
                    <div class="col-6 my-3 text-center">
                      <b-progress
                        class="progress shadow-none rounded-pill mb-2"
                        style="height:10px"
                        height="10px"
                      >
                        <b-progress-bar
                          class="bg-brand-secondary rounded"
                          :value="percentageClaimsInRepairVisits()"
                          :max="100"
                          height="4px"
                        />
                      </b-progress>
                      <small>Of Repairs Visits <span class="font-weight-bold">{{ percentageClaimsInRepairVisits(true) }}</span></small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-5">
          <div class="card flex-grow-1">
            <div class="card-body align-items-center">
              <div v-if="!isLoadingLeakCategoriesList">
                <DoughnutChart
                  title="Leaks Fixed"
                  :show-labels="true"
                  :chart-data="leaksFixedChartData"
                  :options="{
                    cutoutPercentage: 60,
                    tooltips: { enabled: true, },
                  }"
                />
              </div>
              <span v-else>
                <i class="fa fa-spinner fa-spin" />
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-3">
          <div class="card">
            <div class="card-body align-items-center">
              <h4 class="font-weight-bold">
                Customer Feedback
              </h4>
              <hr>
              <div v-if="!isLoadingCustomerFeedbackList">
                <ScrollShadowContainer
                  max-height="145px"
                  shadow-height="8px"
                  shadow-color="rgba(248, 249, 250, 0.9)"
                >
                  <div
                    v-for="(item, index) in customerFeedbackList"
                    :key="item.leakbot_id"
                  >
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="font-weight-bold font-lg">
                        {{ item.first_name }} {{ item.last_name }}
                      </div>
                      <div>
                        <star-rating
                          :rating="Number(item.csat_engineer_visit)"
                          :border-width="4"
                          active-color="#22D3C5"
                          inactive-color="white"
                          border-color="#22D3C5"
                          :rounded-corners="false"
                          :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                          :star-size="12"
                          :show-rating="false"
                          :read-only="true"
                        />
                      </div>
                    </div>
                    <div class="mb-2">
                      <small>
                        {{ item.created_on | moment }}
                      </small>
                    </div>
                    <div class="mb-2">
                      {{ item.customer_feedback }}
                    </div>
                    <div class="font-weight-bold font-lg">
                      {{ item.leakbot_id }}
                    </div>
                    <hr v-if="index !== customerFeedbackList.length - 1">
                  </div>
                </ScrollShadowContainer>
              </div>
              <div
                v-if="isLoadingCustomerFeedbackList"
                class="text-center"
              >
                <i
                  class="fa fa-spinner fa-spin"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import dashboardMixin from "@/mixins/dashboardMixinV2";
import DoughnutChart from "../../charts/chartjs/DoughnutChart.vue";
import BarComboChart from "../../charts/chartjs/BarComboChart.vue";
import ScrollShadowContainer from '@/components/ScrollShadowContainer.vue'

export default {
  name: "DashboardV2",
  components: {
    DoughnutChart,
    BarComboChart,
    ScrollShadowContainer
  },
  mixins: [dashboardMixin],
  data() {
    return {
      tenantSelection: null,
      dateFrom: this.formatDate(new Date(2024, 0, 1)),
      dateTo: this.formatDate(new Date(2026, 11, 31))
    };
  },
  computed: {
    lastUpdatedDate() {
      if (!this.lastInvoiceMonth) return null;
      return moment(this.lastInvoiceMonth).endOf('month').format('DD MMM YYYY');
    },
    npsChartData() {
      const score = this.averageNPS[0] || 0;
      const remainder = 100 - score;
      
      return {
        datasets: [{
          data: [score, remainder],
          backgroundColor: [
            this.getScoreColor(score),
            this.getScoreColor(score) + '10'
          ],
          borderRadius: 50,
          borderWidth: 0
        }]
      };
    },
    csatChartData() {
      const score = this.averageCSAT[0] || 0;
      const remainder = 100 - score;
      
      return {
        datasets: [{
          data: [score, remainder],
          backgroundColor: [
            this.getScoreColor(score),
            this.getScoreColor(score) + '10'
          ],
          borderWidth: 0
        }]
      };
    },
    leaksFixedChartData() {
      // Extract clean category names from HTML-formatted labels
      const cleanLabels = this.leakCategories.map(label => 
        label.replace(/<[^>]*>/g, '').replace(/\s+\d+%/, '')
      );

      return {
        labels: cleanLabels,
        datasets: [{
          data: this.totalRepairs.map((value) => typeof value === 'number' ? value.toFixed(1) : value),
          backgroundColor: ["#0B1A51", "#9e07a7", "#22D2C5", "#FF5A6E"],
          borderWidth: 0
        }]
      };
    }
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
      const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
      return `${year}-${month}-${day}`;
    },

    getScoreColor(value) {
      return value < 60 ? '#ec2819' : '#1e7b0b';
    }
  }
};
</script>
